import { IconProps, iconA11yProps } from '../types';

export const List = ({ classNames, label }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" strokeWidth="2" className={classNames} {...iconA11yProps(label)}>
        <rect x="3" y="3" width="18" height="4" rx="1.5" />
        <rect x="3" y="10" width="18" height="4" rx="1.5" />
        <rect x="3" y="17" width="18" height="4" rx="1.5" />
    </svg>
);
